import * as React from 'react';
import classNames from "classnames";
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcons } from 'src/constants/fontAwesomeIcons';

import './TreeNode.scss';

interface ITreeNodeProps {
    name: string;
    id: string;
    icon: IconDefinition;
    onToggle: (id: string, navigate?: boolean) => void;
    toggled?: boolean;
    collapsible: boolean;
}

class TreeNode extends React.PureComponent<ITreeNodeProps, any> {

    render() {

        const {
            id,
            name,
            icon,
            onToggle,
            toggled,
            collapsible
        } = this.props;

        return (
            <div 
                className={classNames(
                    "tree-node-container", 
                    "list-group-item", 
                    "list-group-item-action", 
                    "-clickable", 
                    "rounded-0", 
                    id?.includes('tableheader') ? "" : "pointer" , 
                    "d-flex", 
                    "justify-content-between",
                    "align-items-center",
                    id?.includes('tableheader') ? "tableheader-container" : ""
                )}
                onClick={() => {
                    onToggle(id, true);
                }}
            >
                <div className='h-100 w-100'>
                    {icon && (
                        <FontAwesomeIcon className="pr-4" icon={icon} />
                    )}
                    {name}
                </div>
                {collapsible && (
                    <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={(e) => {
                            e.stopPropagation();
                            onToggle(id);
                        }}
                        type="button"
                    >
                        { 
                            toggled ? 
                                <FontAwesomeIcon
                                    icon={FontAwesomeIcons.Light.UP} 
                                    fixedWidth
                                /> :
                                <FontAwesomeIcon
                                    icon={FontAwesomeIcons.Light.DOWN} 
                                    fixedWidth
                                />
                        }
                    </button>
                )}
            </div>

        );
    }
}
export default TreeNode;